<template>
  <WdsStack direction-column gap-sm>
    <WdsStack justify-space-between class="tw-grow tw-text-gray-600">
      <span>
        {{
          store.paymentRequestType === PaymentRequestTypeEnum.TIME_X_RATE
            ? $t('Billable time')
            : $t('Billable total')
        }}
      </span>
      <span>{{ store.currency }} {{ calculationsStore.totalCharged }}</span>
    </WdsStack>
    <WdsStack
      v-for="taxLine in taxStore.allTaxLines"
      :key="taxLine.terminology"
      justify-space-between
      class="tw-grow tw-text-gray-600"
    >
      <span>{{ taxLine.terminology }} ({{ taxLine.ratePercentage }}%)</span>
      <span>{{ store.currency }} {{ taxLine.amountCharged }}</span>
    </WdsStack>
    <WdsStack justify-space-between class="tw-grow">
      <span>{{ $t('Subtotal') }}</span>
      <span>{{ store.currency }} {{ calculationsStore.subTotal }}</span>
    </WdsStack>
  </WdsStack>
</template>

<script setup lang="ts">
import { WdsStack } from '@worksome/wds-components'
import { PaymentRequestTypeEnum } from '@/components/PaymentRequest/enums'
import { useTranslation } from '@/composables/translation'
import { usePaymentRequestStore } from '@/components/PaymentRequest/store/usePaymentRequestStore'
import { useCalculationsStore } from '@/components/PaymentRequest/store/useCalculationsStore'
import { useTaxStore } from '@/components/PaymentRequest/store/useTaxStore'

const { $t } = useTranslation()
const store = usePaymentRequestStore()
const calculationsStore = useCalculationsStore()
const taxStore = useTaxStore()
</script>
